/* Usage example "lessors" : { "type" : "select-entity", "entityId" :
ObjectId("5d27667e08806a9aeb81d92b"), "itemText" : { "columns" : [ "nume",
"prenume" ], "displayFormat" : "c_nume c_prenume" }, "addButtonLabel" : "Adauga
arendator", "selectPlaceholder" : "Selecteaza arendator", "crudFormRedirect" :
false } */

<template>
  <v-layout v-if="items == null" justify-center align-center>
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-layout>
  <v-container v-else>
    <v-card class="pa-3">
      <v-layout row wrap>
        <v-flex xs-4>
          <v-autocomplete
            v-model="select"
            :items="items"
            item-text="label"
            item-value="_id"
            :placeholder="selectPlaceholder"
            sigle-line
          ></v-autocomplete>
        </v-flex>
        <v-flex xs-3>
          <v-dialog v-model="dialog">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark v-on="on">{{ addButtonLabel }}</v-btn>
            </template>
            <CrudForm
              :entity-id="entityId"
              :crud-form-redirect="crudFormRedirect"
              @entryAdded="onAddEntry"
            />
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import ApiService from '../APIService'
export default {
  name: 'SelectEntityWidget',
  components: {
    CrudForm: () => import('../forms/CrudForm.vue')
  },
  props: {
    entityId: {
      type: String,
      required: true
    },
    addButtonLabel: {
      type: String,
      default: null
    },
    initialValue: {
      type: Object,
      default: null
    },
    itemText: {
      type: Object,
      required: true
    },
    selectPlaceholder: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    crudFormRedirect: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      selectedEntry: this.initialValue || { entryId: null, entityId: null },
      updates: 0,
      items: null,
      select: { _id: null, label: '' }
    }
  },
  computed: {},
  watch: {
    select: function(val) {
      this.$emit('input', {
        entityId: this.entityId,
        entryId: val
      })
    }
  },
  async mounted() {
    this.loadData()
  },
  methods: {
    replaceFalseHeaders(item, displayFormat, columns) {
      for (let i = 0; i < columns.length; i++) {
        displayFormat = displayFormat.replace(
          'c_' + columns[i],
          item[columns[i]]
        )
      }
      console.log(displayFormat)
      return displayFormat
    },
    onAddEntry() {
      this.dialog = false
      this.items = null
      this.loadData()
    },
    async loadData() {
      try {
        var queryId = await ApiService.getForm(this.entityId, 'list').then(
          (response) => {
            if (response.status !== 200) throw 'Error loading list form'
            return response.data.queryId
          }
        )
        var queryResult = await ApiService.getQueryDataWithFilters(
          queryId,
          null,
          null,
          null,
          null,
          null,
          null
        ).then((response) => {
          if (response.status !== 200) throw 'Error loading query result'
          return response.data
        })
        this.items = []
        for (let i = 0; i < queryResult.length; i++) {
          this.items.push({
            _id: queryResult[i]._id,
            label: this.replaceFalseHeaders(
              queryResult[i],
              this.itemText.displayFormat,
              this.itemText.columns
            )
          })
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
